import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import classnames from 'classnames';
import styles from './styles.module.scss';

if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

const ModalApproveDecline = ({
                               isOpen,
                               closeModal,
                               approveFunc,
                               message,
                               customButtons
                             }) => {
  const contentDirection = "rtl";

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      className={classnames(styles.modal, styles[contentDirection])}
      overlayClassName={styles.overlay}
    >
      <div dir={contentDirection} className={styles.modalContainer}>
        <div className={styles.content}>
          <div className={styles.text}>
            {message}
          </div>
          {Boolean(customButtons)
            ? customButtons
            : (
              <div className={styles.buttonsContainer}>
                <button className={styles.buttonDecline} onClick={closeModal}>
                  ביטול
                </button>
                <button className={styles.buttonApprove} onClick={approveFunc}>
                  החלף
                </button>
              </div>
            )
          }
        </div>
      </div>
    </Modal>
  );
};

ModalApproveDecline.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
  approveFunc: PropTypes.func,
  message: PropTypes.string,
  customButtons: PropTypes.node,
};

export default ModalApproveDecline;
